/* import __COLOCATED_TEMPLATE__ from './actions-for-visible.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();